import './App.css';
import React, {useState} from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import { saveAs } from 'file-saver'
import { write, utils } from 'xlsx'
import axios from "axios";
import { api, legacyPhpUrl } from "./api/client";
import {adaptV4Theme, createTheme, ThemeProvider} from '@mui/material/styles';
import Button from '@mui/material/Button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Link from '@mui/material/Link';

// İkonları temsil eden bileşenler
import PhotoIcon from '@material-ui/icons/Photo';
import VideoIcon from '@material-ui/icons/VideoLibrary';
import moment from "moment";
import Select from "react-select";
import CustomToolbarKirmiziDefterSelect from "./CustomToolbarKirmiziDefterSelect";
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";


class KirmiziDefter extends React.Component {
    constructor(props) {
        super(props);
        this.state={replace: "", datas:[], hata_kodlari:[], departmanlar:[], open:false, id:"", secili_hata_kodu:"", secili_departman:""};
        this.getDatas = this.getDatas.bind(this); // Bu satırı ekleyin
    }
    async getDatas(){

        const res = await api.get('/kirmizi-defter/notlar')
        const data = res.data

        const products = data.map(d => ({
            "id":d.id ,
            "is_emri_no" :  d.is_emri_no,
            "uyfler" :  d.uyfler,
            "personeller" :  d.personeller,
            "tarih" :  d.is_emri_tarihi,
            "aciklama":d.aciklama,
            "musteri":d.musteri,
            "files":d.files
        }))
        //console.log(products);
        this.setState({datas: products})



    }
    refreshPage(response){
        if(response=='success') {
            toast.success("Başlarıyla TYS'ye aktarıldı");
            setTimeout(()=>{window.location.reload();},1000)
        }
        else {
            toast.error("TYS aktarımı sırasında bir hata oluştu. ");

        }

    }
    componentDidMount() {
        this.getDatas(true);
    }
    componentDidUpdate(prevProps,prevState,snapshot) {
            //this.getDatas(true);
    }



    handleClose() {
        this.setState({open:false})
    }
    render() {
        const theme  = createTheme(adaptV4Theme({
            overrides: {
                MUIDataTableHead:{
                    root:{
                        lineHeight:0.5,
                        maxHeight:"10px",
                        padding:0
                    }
                },
                MUIDataTableBodyRow: {
                    root: {
                        '&:nth-child(odd)': {
                            backgroundColor: '#eee'
                        },
                        '&:nth-child(even)': {
                            backgroundColor: '#fff'
                        },
                        lineHeight: 1,
                        padding:1
                    },
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: "#e59e53 !important",
                        fontWeight: "bold",
                        padding:5
                    },
                    root: {
                        lineHeight:1
                    }
                },

            },
        }));
        Date.prototype.addDays = function (days) {
            let date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        }
        function formatDate(value) {
            // Eğer value boşsa, boş bir string dön
            if (!value) return "";

            // Tarih string'ini düzelt
            let reportDate = value.replace(/\\\//g, "/");

            // reportDate'i kontrol et ve moment ile formatla
            if (reportDate !== "") {
                const date = moment(reportDate, "DD/MM/YYYY");
                if (date.isValid()) { // Geçerli bir tarih ise
                    // İstediğiniz formatta bir string olarak dön
                    return date.format("DD/MM/YYYY");


                }
            }

            // Geçersiz bir tarihse, boş bir string dön
            return "";
        }
        const data =  this.state.datas;
        const columns = [
           {
                name: "is_emri_no",
                label: "İş Emri No",
                options: {
                    filter: false,

                    customFilterListOptions: { render: v => `Teklif NO: ${v}` },
                },
            },
            {
                name: "tarih",
                label: "Tarih",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                moment(new Date(value)).format('DD/MM/yyyy')
                            );

                        }
                    },
                },
            },
                {
                name: "personeller",
                label: "Personel",
                options: {
                    filter: true,
                    filterOptions: {
                        fullWidth: true
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let personel=JSON.parse(value)
                        if (value) {
                            return (
                                personel.join(" , ")
                            );

                        }
                    }
                }
            },
            {
                name: "musteri",
                label: "Müşteri",
                options: {
                    filter: true,
                    filterOptions: {
                        fullWidth: true
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                value.substring(0, value.indexOf(' '))
                            );

                        }
                    }
                }
            },

            {
                name: "uyfler",
                label:"UYF No",
                options: {
                    filter: true,

                    filterOptions: {
                        fullWidth: true
                    },

                    //customFilterListOptions: { render: v => `Salary: ${v}` },
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let uyfler=JSON.parse(value)
                        if (value) {
                            return (
                                uyfler.join(" , ")
                            );

                        }
                    }
                }
            },
            {
                name: "aciklama",
                label:"Açıklama",
                options: {
                    filter: true,

                    filterOptions: {
                        fullWidth: true
                    },

                    //customFilterListOptions: { render: v => `Salary: ${v}` },
                    sort: false,

                }
            },
            {
                name: "id",
                label: "Dosyalar",
                options: {
                    filter: false,
                    customBodyRender: (value, meta, updateValue) => {
                        if (value) {

                            let rowData=this.state.datas.filter(item => item.id === value) ;
                            let files= rowData[0].files
                            let is_emri_no=rowData[0].is_emri_no
                            let tarih=rowData[0].tarih
                            console.warn(files)
                            const data = JSON.stringify(files);
                            const mediaItems = JSON.parse(data);
                            if(mediaItems) { return (

                                    <div>
                                        {mediaItems.map((item, index) => (
                                            <Link key={index} href={"http://192.168.2.6/dosyalar/"+is_emri_no+"/"+tarih+"/" +item.uri} target={'_blank'}>
                                                {item.mediaType === 'photo' ? <PhotoIcon /> : <VideoIcon />}
                                            </Link>
                                        ))}
                                    </div>


                            );
                        }

                        }
                    },
                 },
            },
            {
                name: "id",
                label: "Rapor",
                options: {
                    filter: false,
                    customBodyRender: (value, meta, updateValue) => {
                        if (value) {
                            const record = data[meta.currentTableData[meta.rowIndex].index];
                            return (
                                <a href={legacyPhpUrl('kirmizi_defter_rapor.php?id='+value)} target={'_blank'} rel="noreferrer">Rapor Aç</a>
                            );

                        }
                    },
                    customFilterListOptions: { render: v => `Teklif NO: ${v}` },
                },
            },

        ];


        let datas=[];
        const options = {
            filter: true,
            onFilterChange: (changedColumn, filterList) => {
                console.log(changedColumn, filterList);
            },

            selectableRows: 'multiple',
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: 100,
            fixedHeader: true,
            //fixedSelectColumn: true,
            tableBodyHeight: '100%',
            print:false,
            download:true,
            searchOpen:true,
            draggableColumns: {
                enabled:false,
                transitionTime:400
            },
            rowStyle: {
                fontSize: 9,
                lineHeight:0.1
            },
            downloadOptions: {
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },
            onRowSelectionChange : (curRowSelected, allRowsSelected) => {
                datas.length=0;
                console.log("---RowSelect")
                console.log("Row Selected: ", curRowSelected);
                console.log("All Selected: ", allRowsSelected);

                if(allRowsSelected) {
                    allRowsSelected.forEach((result)=>{
                        datas.push(data[result.dataIndex]);
                    })
                }
            },
            textLabels :{
                body: {
                    noMatch: "Bu tabloda hiç bir veri yok",
                    toolTip: "Sırala",
                    columnHeaderTooltip: column => `${column.label} için sırala`
                },
                selectedRows: {
                    text: "satır seçildi",
                    delete: "SiparişeEkle",
                    deleteAria: "Seçilenleri siparişe aktar",
                },
                pagination: {
                    next: "İleri",
                    previous: "Geri",
                    rowsPerPage: "Sayfadaki satır sayısı:",
                    displayRows: "/",
                },
                toolbar: {
                    search: "Ara",
                    downloadCsv: "XLSX İndir",
                    print: "Çıktı Al",
                    viewColumns: "Sütunları Göster",
                    filterTable: "Tabloyu Süz",
                },
                filter: {
                    all: "Tümünü Göster",
                    title: "Filtreler",
                    reset: "Sıfırla",
                },
                viewColumns: {
                    title: "Sütunları Göster",
                    titleAria: "Sütunları Göster/Gizle",
                },

            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const fileExtension = ".xlsx";

                console.log(values.forEach(val => console.log(val)));

                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => {
                        temp[columns[idx].name] = v;
                    });
                    result.push(temp);
                    return result;
                }, []);

                const fileName = `Taslak İş Emirleri Listesi`;
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName + fileExtension);
                // cancel default  CSV download from table
                return false;
            },
            customToolbarSelect: (selectedRows) => <CustomToolbarKirmiziDefterSelect selectedRows={selectedRows}  getDatas={this.refreshPage}  data={datas}/>

        };

        return (

            <ThemeProvider theme={theme}>


                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover

                />
                <MUIDataTable title={"Kırmızı Defter"} data={data} columns={enhanceColumns(columns)} options={withTableOptions(options)} />



            </ThemeProvider>
        );

    }


}

export default KirmiziDefter;
